import { IElementToSimpleSapElementMapperFactory } from '../IElementToSimpleSapElementMapperFactory';
import Element, { ElementType } from '@/models/element';
import { IElementToSimpleSamElementsMapper } from '../elementToSimpleSapElementsMapper';
import { NullToSimpleSapELementMapper } from '../nullToSimpleSapElementMapper';
import { BedAllElementToSimpleSapElementMapper } from './bedAllElementToSimpleSapElementMapper';

export class BedElementToSimpleSapElementMapperFactory
    implements IElementToSimpleSapElementMapperFactory {

    private all = new BedAllElementToSimpleSapElementMapper();
    private null = new NullToSimpleSapELementMapper();

    public getMapperFor(element: Element): IElementToSimpleSamElementsMapper {
        if (element.type === ElementType.BODY) {
            return this.all;
        }
        return this.null;
    }
}
